import './front.css';
import React from 'react';
import leftarrow from './img/flèche CTA retour.svg'
import logo from './img/Logo assur bon plan.png'
import telephone from './img/icon telephone.svg'
import FrontLanding from './front/landing'
import FrontDetails1 from './front/details1';
import FrontConfirmTarif from './front/confirmTarif';
import FrontVous from './front/vous';
import FrontVehicule from './front/vehicule';
import FrontAntecedents from './front/antecedents';
import FrontError from './front/error';
import FrontSubscribeError from './front/subscribeError';
import FrontCancelled from './front/cancelled';
import FrontSubscribing from './front/subscribing';
import FrontReceive from './front/receive';
import FrontPayment from './front/payment';
import FrontPaidSubscribed from './front/paid_subscribed';
import FrontSubscribedSolly from './front/subscribed_solly';
import FrontSubscribeSolly from './front/subscribe_solly';
import DataDevis from './dataDevis'
import Footer from './front/footer';
import BlueHeader from './front/blueHeader'
import waiter from './img/wait.svg'

class Front extends React.Component {
    
    constructor(props) {
        super(props);
        const {page} = this.readHash()
        this.state = {
            devis: false,
            page: page,
            waiting: false,
            enableClientSubscription:false,
            preClosed:false,
            affiliateLogin:false,
            affiliate:{},
            sponsor:{}
        }
        this.enableClientSubscription = false
        this.preClosed = false
        this.checkingStatus = false
        this.changingPage = false
        this.topRef = React.createRef()
        this.statusToPage = {
            'paid_subscribed':'paid_subscribed',
            'subscribed_solly':'subscribed_solly',
            'subscribing':'subscribing',
            'subscribe_error':'subscribe_error',
            'presubscribe_error':'subscribe_error',
            'cancelled':'cancelled'
        }
        if ( ! this.props.embeded ) {
            window.addEventListener("hashchange", this.onHashChange.bind(this), false);
        }
    }


    componentDidMount() {
        this.props.api.registerDevisView(this)
        this.props.api.registerEnableView(this)
        if ( this.props.id ) {
            this.props.api.post(
                {action:'get_devis',
                 id:this.props.id},
                ()=>{}
            )
        } else {
            this.props.api.post(
                {   action:'create_devis',
                    affiliate:this.props.api.affiliate
                },
                ()=>{}
            )
        }
    
    }

    componentWillUnmount() {
        this.props.api.unregisterDevisView(this)
        this.props.api.unregisterEnableView(this)
    }

    setEnableClientSubscription(enabled) {
        this.enableClientSubscription = enabled
        this.setState({enableClientSubscription:enabled})
    }

    setPreClose(closed) {
        this.preClosed = closed
        this.setState({preClosed:closed})
    }

    setPage(page,force=false) {
        const devis = this.state.devis
        if (( !force )&&( devis.status_process in this.statusToPage )) {
            page = this.statusToPage[devis.status_process]
        }
        if ( this.props.embeded ) {
            this.setState({page:page})
            this.changingPage = true
        } else {
            window.location.hash='#'+page
        }
    }


    validatePayment() {
        if ( window.confirm('Attention ! La souscription va être lancée sans paiement. Êtes-vous sûr que le paiement a déjà été réalisé ou sera réalisé par un autre moyen ?') ) {
            this.props.api.post(
                {
                    action:'validate_payment',
                    id:this.props.id
                },
                ()=>{}
            )
        }
    }

    sendPaymentLink() {
        this.props.api.post(
            {
                action:'send_payment_link',
                id:this.props.id
            },
            ()=>{
                alert('L\'email est posté. Lorsque le client aura payé, les documents lui seront envoyés automatiquement.')
            }
        ) 
    }

    changeParams(params) {
        this.props.api.post(
            {
                action:'change_params',
                id:this.props.id,
                params:JSON.stringify(params),
                devis_timestamp:Date.now()
            },
            ()=>{}
        )
/*
        let devis = this.state.devis
        for ( const field in params ) {
            devis.params[field] = params[field]
        }
        this.setState({devis:devis})
*/
    }

    readHash() {
        let match = window.location.hash.match(/#(.*)$/)
        return {page:( match &&( match[1] !== undefined ) )? decodeURIComponent(match[1]) : '' }
    }

    onHashChange() {
        let {page} = this.readHash()
        const devis = this.state.devis
        if ( devis.status_process in this.statusToPage ) {
            page = this.statusToPage[devis.status_process]
        }
        if ( page != this.state.page ) {
            this.changingPage = true
            this.setState({page:page})
        }
    }

    receiveDevis(devis) {

        const me = this
        if ( this.props.id == devis._id.$oid ) {

            if (( devis.status_process == 'paid_unsubsribed' )&&( devis.validated > 0 ))  {
                devis.status_process = 'subscribing'
                this.changingPage = true
                this.props.api.post(
                    {
                        action:'subscribe',
                        id:this.props.id
                    },
                    ()=>{}
                )
            }

            if ( this.enableClientSubscription &&(
                (( devis.status_process == 'paid_subscribed' )&&( ! devis.getting_documents ))||(
                ( devis.getting_documents < 0 )&&( devis.getting_documents >= -2 )
            ))) {
                console.log(devis,devis.getting_documents)
                devis.getting_documents = 1
                this.props.api.post(
                    {
                        action:'get_documents',
                        id:this.props.id
                    },
                    ()=>{}
                )
            }

            if ( ! devis.params.own_iban ) {
                this.changeParams({own_iban:'O'})
            }

            if ( ! this.state.page ) {
                if (( devis.status_process=='ongoing' )||( devis.status_process=='En cours' )) {
                    this.setState({page: ((devis.params.MER)||(devis.params.tarif_choisi==0)) ? 'landing' : 'vehicule' })
                } else {
                    this.setState({page: this.statusToPage[devis.status_process] })    
                }
            } else {
                if ( devis.status_process in this.statusToPage ) {
                    this.setState({page:this.statusToPage[devis.status_process]})
                }
            }

            if ( devis.affiliate != this.state.affiliateLogin ) {
                this.props.api.post(
                    {action:'get_sponsor_contact',
                    login:devis.affiliate},
                    (res)=>{
                        me.setState({affiliate:res.contact,sponsor:res.sponsor})
                    }
                )
            }

            this.setState({devis:devis,waiting:false,affiliateLogin:devis.affiliate})

        }
    }

    componentDidUpdate(prevProps, prevState) {
        const me = this
        const pageToResync = {
            'landing':true,
            'confirm_tarif':true
        }

        if (
            ( !this.state.waiting )
            &&( ! this.state.devis.synchronized )
            &&( pageToResync[this.state.page] )
            &&( this.state.devis.status_process == 'ongoing' )
            &&( this.enableClientSubscription&&!this.preClosed )
        ) {
            this.setState({waiting:true})
            this.props.api.post(
                {
                    action:'get_devis',
                    resync:true, // This forces re-synchronization : calculates prices by contacting xenassur
                    id:this.props.id
                }
            )
        }

        if ( this.changingPage ) {
            if ( this.topRef.current ) {
                this.topRef.current.scrollIntoView({behavior:'instant'});
                this.changingPage = false
            }
        }
    }

    resync() {
        this.props.api.post( {
                action:'get_devis',
                resync:true, // This forces re-synchronization : calculates prices by contacting xenassur
                id:this.props.id
            },
            ()=>{}
        )
    }

    restart() {

        let devis = this.state.devis
        if ( this.enableClientSubscription 
            && ( devis.status_process == 'presubscribe_error' )
        ) {
            devis.status_process = 'subscribing'
            devis.params.error = false
            this.changingPage = true
            this.props.api.post(
                {
                    action:'subscribe',
                    id:this.props.id
                },
                ()=>{}
            )
            this.setState({
                devis:devis,
                page: this.statusToPage[devis.status_process]
            })
        }
    }
    
    checkStatus( ignoreFields ) {
        if ( !this.checkingStatus ) {
            this.checkingStatus = true
            let payload = {
                action:'get_devis',
                id:this.props.id
            }
            if ( ignoreFields ) {
                payload.ignore_fields = JSON.stringify(ignoreFields)
            } else {
                payload.ignore_status = this.state.devis.status_process
            }
            this.props.api.post(
                payload,
                ()=>{
                    this.checkingStatus = false
                }
            )
        }
    }

    ignoreTransaction() {
        if ( window.confirm('Attention, si le client est déjà sur la page de paiement et que vous ignorer cet ordre de paiement, il risque de payer un montant incorrect.') ) {

        }
    }

    validateDevis() {
        const me = this
        if ( this.enableClientSubscription && ( !this.state.devis.validated )&& this.state.devis.synchronized ) {

            let devis = this.state.devis
            devis.validated = -1
            this.setState({devis:devis})

            this.validatingDevis = true
            this.props.api.post(
                {
                    action:'validate_devis',
                    id:this.props.id,
                    devis_timestamp:Date.now()
                },
                (res)=>{
                    if ( res.devis.validated <= -2 ) {
                        // Force devis reception in case of failed validation
                        // This overrids the timestamp filter
                        const dataDevis = new DataDevis(res.devis)
                        me.receiveDevis(dataDevis)
                    }
                }
            )
        }
    }

    getComponent() {
        
        const devis = this.state.devis
        if (( this.state.devis.params.error||(this.state.devis.validated==-2) )&& {
            'landing':true,
            'details1':true
        }[this.state.page] ) {
            const solly = devis.getSolly()
            if (( ! solly.hasSolly() )||( this.state.page == 'details1' )) {
                return FrontError
            }
        }

        if (( ! this.enableClientSubscription )&& !{
            'paid_subscribed':true,
            'subscribed_solly':true,
            'subscribe_error':true,
            'presubscribe_error':true
        }[this.state.page] ) return FrontLanding

        if (( this.preClosed )&& !{
            'subscribing':true,
            'payment':true,
            'subscribed_solly':true,
            'paid_subscribed':true,
            'subscribe_error':true,
            'presubscribe_error':true
        }[this.state.page] ) return FrontLanding

        return {
            'landing':FrontLanding,
            'receive':FrontReceive,
            'receive2':FrontReceive,
            'details1':FrontDetails1,
            'confirm_tarif':FrontConfirmTarif,
            'vehicule':FrontVehicule,
            'vous':FrontVous,
            'antecedents':FrontAntecedents,
            'subscribe_error':FrontSubscribeError,
            'presubscribe_error':FrontSubscribeError,
            'cancelled':FrontCancelled,
            'subscribing':FrontSubscribing,
            'paid_subscribed':FrontPaidSubscribed,
            'subscribed_solly':FrontSubscribedSolly,
            'payment':FrontPayment,
            'subscribe_solly':FrontSubscribeSolly
        }[this.state.page] || FrontLanding
    }

    render() {
        const waiting = this.state.waiting ||( ! this.state.devis )
        const content = waiting ? '' : React.createElement(
            this.getComponent(), { 
                api:this.props.api, 
                id:this.props.id,
                changeParams:this.changeParams.bind(this), 
                page:this.state.page,
                setPage:this.setPage.bind(this),
                devis:this.state.devis,
                topRef:this.topRef,
                restart:this.restart.bind(this),
                resync:this.resync.bind(this),
                embeded:this.props.embeded,
                checkStatus:this.checkStatus.bind(this),
                validateDevis:this.validateDevis.bind(this),
                validatePayment:this.validatePayment.bind(this),
                sendPaymentLink:this.sendPaymentLink.bind(this),
                enableClientSubscription:this.enableClientSubscription&&!this.preClosed
            }
        )

        return <div className="front">
            <div className="header">
            <div className="headbox headleftaction">
                <div onClick={()=>this.setPage('vehicule')}>
                    <img src={leftarrow}/>
                    Modifier mes <br/> informations
                </div>
            </div>

            <a className="headbox"></a>

            <div className="logobox">
                <a href="https://www.assurbonplan.fr/" target="_blank"><img src={logo}/></a>
            </div>
            
            <a className="headbox"></a>
            <a className="headbox visible1600">Nos assurances</a>
            <a className="headbox visible1600">Guide et conseils</a>
            <a className="headbox visible1600">Qui sommes-nous ?</a>
            <a className="headbox visible1600">Blog</a>
            <a className="headbox visible1600">Contact</a>
            <a className="headbox visible1600">FAQ</a>
            <a className="headbox">Mon espace</a>
            <div className="headbox besoindaide">
                <span>Besoin d'aide ?</span>
                <div>
                    <img src={telephone}/>
                    <span>Contactez nos experts</span>
                    <div>09 74 77 28 61</div>
                </div>
            </div>
        </div>
        { waiting
                ? <div className="bigoverlay"><img src={waiter} className="big_waiter"/></div>
                : '' }
        <BlueHeader affiliate={this.state.affiliate} sponsor={this.state.sponsor}/>
        <div className="body">
        {( this.props.embeded && this.state.devis.in_trs )
            ?<div className="popup_payment">
                Un paiement est en cours, les données tarifantes ne pourront pas être modifiées durant les 10 prochaines minutes.
                {/*<br/><a onClick={this.ignoreTransaction.bind(this)}>▶ Ignorer le paiement en cours</a>*/}
            </div>
            :''}
            
            {content}
        </div>
        <Footer setPage={this.setPage.bind(this)}/>
        </div>
    }
}

export default Front;
